import { PaperClipOutlined } from '@ant-design/icons'
import { DEFAULT_TEXT_LENGTH } from '@Orders/OrderDetailsPage/Status/logic'

import Box from '~/core/Box'
import TruncatedText from '~/core/TruncatedText'
import Text from '~/core/Text'
import {
    BLACK_ALPHA_BOTTOM,
    HEADER_STYLES,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { TwoDdrawingType } from '~/apps/consumer/components/PartViewerModal/types'
import SafeDownloadLink from '~/apps/consumer/components/SafeDownloadLink'

export default function TwoDdrawing(props: TwoDdrawingType) {
    const {
        placement,
        twoDdrawing: { fileName, downloadUrl },
    } = props

    return (
        <>
            <Text style={{ ...HEADER_STYLES, paddingTop: '16px' }}>
                Inspection drawing
            </Text>
            <Box
                borderBottom={BLACK_ALPHA_BOTTOM}
                paddingBottom="16px"
                justifyContent="between"
            >
                <SafeDownloadLink
                    name="download-attachment"
                    placement={placement}
                    downloadUrl={downloadUrl}
                    fileName={fileName}
                    style={{ marginTop: 5 }}
                >
                    <PaperClipOutlined />
                    <TruncatedText maxLength={DEFAULT_TEXT_LENGTH}>
                        {fileName}
                    </TruncatedText>
                </SafeDownloadLink>
            </Box>
        </>
    )
}
